import React from 'react'
import { graphql } from 'react-apollo'
import createG2 from 'g2-react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
// import _values from 'lodash/values'
import _get from 'lodash/get'
// import _set from 'lodash/set'
// import _setWith from 'lodash/setWith'
import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'

import config from '~/config'
import poisQuery from '~/graphql/queries/pois.gql'
// import user from '~/user.json'
// const colors = _values(config.ui.colors)

const typeNameMaps = {}

const ResponseDataChart = ({ dataRecords, dataTypeIds = [], category, view: { mode, daysOffset, stationIds = [], poiIds = [] }, data: { stations }, pois, today }) => {
  // const today = moment(now).hour(0).minute(0).second(0)
  // let max = 0
  const startDate = today.format('YYYY-MM-DD@HH:mm:ss')
  const endDate = today.clone().add({ days: 7 }).format('YYYY-MM-DD@HH:mm:ss')
  const [ typeId ] = dataTypeIds
  const typeConfig = _get(config, 'app.parameters').find(t => t.id === parseInt(typeId, 10))
  /*
  const dataValues = _values(dataRecords.reduce((result, rec) => {
    // console.log(rec.observedTimestamp)
    // max = rec.value > max ? rec.value : max
    _setWith(result, [rec.observedTimestamp, rec.typeName], rec.value, Object)
    _set(result, [rec.observedTimestamp, 'observedTimestamp'], moment(rec.observedTimestamp).format('YYYY-MM-DD@HH:mm:ss'))
    // _set(result, [rec.observedTimestamp, 'observedTimestampISO'], moment(rec.observedTimestamp).toISOString())
    return result
  }, {}))
  const dataSource = _sortBy(dataValues, ['observedTimestamp'])
*/
  stationIds.forEach((stationId, i) => {
    const station = stations.find(s => s.id === stationId)
    const stationName = _get(station, 'stationName')
    typeNameMaps[`s${stationId}`] = stationName
  })
  poiIds.forEach((poiId, i) => {
    const poi = pois.find(p => p.id === poiId)
    if (poi) {
      const poiName = _get(poi, 'poiName')
      typeNameMaps[`p${poiId}`] = poiName
    }
  })
  const dataTypeTitle = `${_get(typeConfig, 'name')} (${_get(typeConfig, 'unit', '')})`
  const dataSource = _sortBy(dataRecords, ['observedTimestamp'])
    .map(({ typeName, value, observedTimestamp }) => ({
      typeName: typeNameMaps[typeName],
      [dataTypeTitle]: value,
      observedTimestamp: moment(observedTimestamp).format('YYYY-MM-DD@HH:mm:ss')
    }))
  let observedTimestamp

  const currentDay = today.clone().add(daysOffset, 'day')
  const record = _find(dataSource, rec => currentDay.isSame(moment(rec.observedTimestamp, 'YYYY-MM-DD@HH:mm:ss', true), 'day'))
  if (record) {
    observedTimestamp = record.observedTimestamp
  }

  const Line = createG2(chart => {
    // let offset = 5
    if (observedTimestamp) {
      chart.guide().line([observedTimestamp, _get(typeConfig, 'min')], [observedTimestamp, _get(typeConfig, 'max')], {
        stroke: '#999'
        // lineDash: [0, 2, 2],
        // lineWidth: 3
      })
    }

    // stationIds.forEach((stationId, i) => {
    //   // console.log({ stationId })
    //   // const typeName = _get(typeConfig, 'name')
    //   const station = stations.find(s => s.id === stationId)
    //   const stationName = _get(station, 'stationName')

    //   chart.axis(`s${stationId}`, {
    //     position: 'left',
    //     labels: {
    //       label: {
    //         fill: colors[i],
    //         fontSize: 8
    //       },
    //       autoRotate: false
    //     },
    //     labelOffset: offset,
    //     title: {
    //       fontSize: 10,
    //       fontWeight: 'bold',
    //       fill: colors[i],
    //       textAlign: 'center'
    //     },
    //     titleOffset: offset + 24
    //   })
    //   chart.col(`s${stationId}`, {
    //     // min: _get(typeConfig, 'min'),
    //     // max: _get(typeConfig, 'max'),
    //     // max,
    //     alias: `${_get(typeConfig, 'name')} ${stationName} (${_get(typeConfig, 'unit', '')})`
    //   })
    //   offset += 40
    //   chart.line().position(`observedTimestamp*s${stationId}`).color(colors[i]).shape('spline').size(2)
    // })

    // poiIds.forEach((poiId, i) => {
    //   // console.log({ poiId })
    //   const typeConfig = _get(config, 'app.parameters').find(t => t.id === parseInt(typeId, 10))
    //   // const typeName = _get(typeConfig, 'name')
    //   const poi = pois.find(p => p.id === poiId)
    //   const poiName = _get(poi, 'poiName')

    //   chart.axis(`p${poiId}`, {
    //     position: 'left',
    //     labels: {
    //       label: {
    //         fill: colors[i],
    //         fontSize: 8
    //       },
    //       autoRotate: false
    //     },
    //     labelOffset: offset,
    //     title: {
    //       fontSize: 10,
    //       fontWeight: 'bold',
    //       fill: colors[i],
    //       textAlign: 'center'
    //     },
    //     titleOffset: offset + 24
    //   })
    //   chart.col(`p${poiId}`, {
    //     // min: _get(typeConfig, 'min'),
    //     // max: _get(typeConfig, 'max'),
    //     // max,
    //     alias: `${_get(typeConfig, 'name')} ${poiName} (${_get(typeConfig, 'unit', '')})`
    //   })
    //   offset += 40
    //   chart.line().position(`observedTimestamp*p${poiId}`).color(colors[i]).shape('spline').size(2)
    // })
    // chart.guide().text({
    //   // top: true,
    //   content: 'titleXXX',
    //   position: [10, 10],
    //   style: {
    //     // fill: '#666',
    //     fontSize: '24',
    //     fontWeight: 'bold',
    //     rotate: 30
    //   }
    // })

    chart.line().position(`observedTimestamp*${dataTypeTitle}`).color('typeName').shape('spline').size(2)
    let prevDate

    chart.axis('observedTimestamp', {
      formatter: (dateTime, item, index) => {
        const $dateTime = moment(dateTime, 'YYYY-MM-DD@HH:mm:ss', true)
        if (!$dateTime.isSame(prevDate, 'day')) {
          prevDate = $dateTime
          // return $dateTime.format('YYYY-MM-DD')
          return $dateTime.format('MMM DD')
        }
        prevDate = $dateTime
        return $dateTime.format('HH:mm:ss')
      },
      labels: {
        label: {
          textAlign: 'right',
          fontSize: 8,
          textBaseline: 'top',
          rotate: -45 * Math.PI / 180
        },
        autoRotate: false
      },
      labelOffset: 0,
      title: false
    })
    // chart.axis(dataTypeTitle, {
    //   title: false
    // })
    chart.col('observedTimestamp', {
      nice: true,
      tickCount: 22,
      min: startDate,
      max: endDate
    })
    chart.legend('typeName', {
      position: 'left',
      title: false
    })
    chart.render()
  })
  return <Line data={dataSource} width={_get(config, 'ui.chartWidth')} height={_get(config, 'ui.chartHeight') + 88} plotCfg={{
    margin: [10, 10, 70, 160]
  }} />
}

export default compose(
  inject('view'),
  inject('data'),
  inject('user'),
  graphql(poisQuery, {
    props: ({ data: { loading, pois, refetch } }) => ({
      loading,
      refetch,
      pois: _get(pois, 'nodes', [])
    }),
    options: ({ user: { profile } }) => ({
      variables: {
        userId: profile.userId
      }
    })
  }),
  observer
)(ResponseDataChart)



// WEBPACK FOOTER //
// ./src/modules/Forecasting/ResponseDataChart.js